import SpaceDashboardIcon from "@mui/icons-material/SpaceDashboard";
import GroupIcon from "@mui/icons-material/Group";
import CategoryIcon from "@mui/icons-material/Category";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import LoyaltyIcon from "@mui/icons-material/Loyalty";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import AssessmentIcon from "@mui/icons-material/Assessment";
import SettingsIcon from "@mui/icons-material/Settings";
import TableRestaurantIcon from "@mui/icons-material/TableRestaurant";
import RoomServiceIcon from "@mui/icons-material/RoomService";

import { ElementType, lazy } from "react";

// Lazy load components for better code splitting
const BDashboard = lazy(
  () => import("../../branch/pages/dashboard/BDashboard"),
);
const BRole = lazy(() => import("../../branch/pages/Staff/role/BRole"));
const BEmployee = lazy(
  () => import("../../branch/pages/Staff/employee/BEmployee"),
);
const Product = lazy(() => import("../../branch/pages/item/product/Product"));
const SubCategory = lazy(
  () => import("../../branch/pages/item/subCategory/SubCategory"),
);
const Brand = lazy(() => import("../../branch/pages/item/product/brand/Brand"));
const Category = lazy(
  () => import("../../branch/pages/item/category/Category"),
);
const Supplier = lazy(
  () => import("../../branch/pages/inventory/supplier/Supplier"),
);
const SupplierInfo = lazy(
  () => import("../../branch/pages/inventory/supplierinfo/SupplierInfo"),
);
const Purchase = lazy(
  () => import("../../branch/pages/inventory/purchase/Purchase"),
);
const Customer = lazy(
  () => import("../../branch/pages/loyalty/customer/Customer"),
);
const Loyalty = lazy(
  () => import("../../branch/pages/loyalty/loyalty/Loyalty"),
);
const Tax = lazy(() => import("../../branch/pages/charges/tax/Tax"));
const ServiceCharge = lazy(
  () => import("../../branch/pages/charges/serviceCharge/ServiceCharge"),
);
const Invoice = lazy(() => import("../../branch/pages/sales/invoice/Invoice"));
const Stock = lazy(
  () => import("../../branch/pages/stockmangement/initialstock/Stock"),
);
const Reports = lazy(() => import("../../branch/pages/reports/Reports"));
const TransferList = lazy(
  () => import("../../branch/pages/stockmangement/stocktransfer/TransferList"),
);
const TableManagement = lazy(
  () => import("../../branch/pages/tablemangement/TableManagement"),
);
const WaiterPage = lazy(() => import("../../branch/pages/waiter/Waiter"));
const CustomerInfo = lazy(
  () => import("../../branch/pages/loyalty/customerinfo/CustomerInfo"),
);
const StockAdjustment = lazy(
  () =>
    import("../../branch/pages/stockmangement/stockadjustment/StockAdjustment"),
);
const PurchaseReturn = lazy(
  () =>
    import("../../branch/pages/stockmangement/purchasereturn/PurchaseReturn"),
);
const ProductPurchaseReportPage = lazy(
  () =>
    import("../../branch/pages/reports/purchaseReport/ProductPurchaseReportPage"),
);
const ProductSalesReportPage = lazy(
  () => import("../../branch/pages/reports/salesReport/ProductSalesReportPage"),
);
const ManagePrint = lazy(
  () => import("../../branch/pages/settings/manageprint/ManagePrint"),
);

type Route = {
  TITLE: string;
  ICON?: ElementType; // For React component icons
  KEY: number;
  PATH: string;
  ELEMENT?: ElementType; // For React page components like Dashboard, Employee, etc.
  DIRECT?: boolean;
  SUBNAV?: Route[]; // Recursive for nested menus
  SUBSUBNAV?: Route[]; // Further nesting if needed
  HIDE?: boolean; // To hide certain routes from navigation
};
export const BRANCHROUTES: Route[] = [
  {
    TITLE: "Dashboard",
    ICON: SpaceDashboardIcon,
    KEY: 1,
    PATH: "/dashboard",
    ELEMENT: BDashboard,
  },
  {
    TITLE: "Item",
    ICON: CategoryIcon,
    KEY: 2,
    PATH: "/branch/item",
    DIRECT: true,
    SUBNAV: [
      {
        TITLE: "product",
        KEY: 21,
        PATH: "/branch/item/product",
        ELEMENT: Product,
      },
      {
        TITLE: "category",
        KEY: 23,
        PATH: "/branch/item/category",
        ELEMENT: Category,
      },
      {
        TITLE: "subCategory",
        KEY: 22,
        PATH: "/branch/item/subCategory",
        ELEMENT: SubCategory,
      },
      {
        TITLE: "brand",
        KEY: 24,
        PATH: "/branch/item/brand",
        ELEMENT: Brand,
      },
    ],
  },
  {
    TITLE: "Stock Management",
    ICON: Inventory2Icon,
    KEY: 3,
    PATH: "/branch/stock",
    DIRECT: true,
    SUBNAV: [
      {
        TITLE: "Stock Adjustment",
        KEY: 31,
        PATH: "/branch/stock/stock-adjustment",
        ELEMENT: StockAdjustment,
      },
      {
        TITLE: "Initial Stock",
        KEY: 32,
        PATH: "/branch/stock/initial-stock",
        ELEMENT: Stock,
      },
      {
        TITLE: "Stock Transfer",
        KEY: 33,
        PATH: "/branch/stock/transfer-stock",
        ELEMENT: TransferList,
      },
      {
        TITLE: "Purchase Return",
        KEY: 34,
        PATH: "/branch/stock/purchase-return",
        ELEMENT: PurchaseReturn,
      },
    ],
  },
  {
    TITLE: "Purchase",
    ICON: ShoppingCartIcon,
    KEY: 4,
    PATH: "/branch/inventry",
    DIRECT: true,
    SUBNAV: [
      {
        TITLE: "purchase",
        KEY: 41,
        PATH: "/branch/inventry/purchase",
        ELEMENT: Purchase,
      },
      {
        TITLE: "supplier",
        KEY: 42,
        PATH: "/branch/inventry/supplier",
        ELEMENT: Supplier,
      },
      {
        TITLE: "supplier info",
        KEY: 43,
        PATH: "/branch/inventry/supplier/:id",
        ELEMENT: SupplierInfo,
        HIDE: true,
      },
    ],
  },
  {
    TITLE: "Staff",
    ICON: GroupIcon,
    KEY: 5,
    PATH: "/branch/staffs",
    DIRECT: true,
    SUBNAV: [
      {
        TITLE: "Employees",
        KEY: 51,
        PATH: "/branch/staffs/employees",
        ELEMENT: BEmployee,
      },
      {
        TITLE: "Roles",
        KEY: 52,
        PATH: "/branch/staffs/roles",
        ELEMENT: BRole,
      },
    ],
  },
  {
    TITLE: "Sales",
    ICON: PointOfSaleIcon,
    KEY: 6,
    PATH: "/branch/sales",
    DIRECT: true,
    SUBNAV: [
      {
        TITLE: "Invoice Lists",
        KEY: 61,
        PATH: "/branch/sales/invoice",
        ELEMENT: Invoice,
      },
    ],
  },

  {
    TITLE: "Loyalty",
    ICON: LoyaltyIcon,
    KEY: 7,
    PATH: "/branch/loyalty",
    DIRECT: true,
    SUBNAV: [
      {
        TITLE: "Customer",
        KEY: 71,
        PATH: "/branch/loyalty/customer",
        ELEMENT: Customer,
      },
      {
        TITLE: "Customer Info",
        KEY: 72,
        PATH: "/branch/loyalty/customer/:id",
        ELEMENT: CustomerInfo,
      },
      {
        TITLE: "loyalty",
        KEY: 73,
        PATH: "/branch/loyalty/loyalty",
        ELEMENT: Loyalty,
      },
    ],
  },
  {
    TITLE: "Charges",
    ICON: RequestQuoteIcon,
    KEY: 8,
    PATH: "/branch/charges",
    DIRECT: true,
    SUBNAV: [
      {
        TITLE: "tax",
        KEY: 81,
        PATH: "/branch/charges/tax",
        ELEMENT: Tax,
      },
      {
        TITLE: "service charge",
        KEY: 82,
        PATH: "/branch/charges/serviceCharge",
        ELEMENT: ServiceCharge,
      },
    ],
  },
  {
    TITLE: "Reports",
    ICON: AssessmentIcon,
    KEY: 9,
    PATH: "/branch/reports",
    // ELEMENT: Reports,
    DIRECT: true,
    SUBNAV: [
      {
        TITLE: "Reports",
        ICON: AssessmentIcon,
        KEY: 91,
        PATH: "/branch/reports/sales",
        ELEMENT: Reports,
      },
      {
        TITLE: "Product Purchase Report",
        KEY: 92,
        PATH: "/branch/reports/product-purchase",
        ELEMENT: ProductPurchaseReportPage,
        HIDE: true,
      },
      {
        TITLE: "Product Sales Report",
        KEY: 93,
        PATH: "/branch/reports/product-sales",
        ELEMENT: ProductSalesReportPage,
        HIDE: true,
      },
    ],
  },
  {
    TITLE: "Table Management",
    ICON: TableRestaurantIcon,
    KEY: 10,
    PATH: "/branch/table-management",
    ELEMENT: TableManagement,
  },
  {
    TITLE: "Waiter Management",
    ICON: RoomServiceIcon,
    KEY: 11,
    PATH: "/branch/waiter-management",
    ELEMENT: WaiterPage,
  },
  {
    TITLE: "Settings",
    ICON: SettingsIcon,
    KEY: 12,
    PATH: "/branch/settings",
    DIRECT: true,
    SUBNAV: [
      {
        TITLE: "Bill Setup",
        KEY: 121,
        PATH: "/branch/settings/manage-print",
        ELEMENT: ManagePrint,
      },
    ],
  },

  // {
  //   TITLE: "Units",
  //   ICON: AccountBalanceIcon,
  //   KEY: 3,
  //   PATH: "/admin/units",
  //   ELEMENT: Units,
  // },
  // {
  //   TITLE: "Branch",
  //   ICON: GroupIcon,
  //   KEY: 4,
  //   PATH: "/admin/branch",
  //   DIRECT: true,
  //   SUBNAV: [
  //     {
  //       TITLE: "branches",
  //       KEY: 41,
  //       PATH: "/admin/branch/branch",
  //       ELEMENT: Branch,
  //     },
  //     {
  //       TITLE: "mart",
  //       KEY: 42,
  //       PATH: "/admin/branch/mart",
  //       ELEMENT: Mart,
  //     },
  //     {
  //       TITLE: "branch roles",
  //       KEY: 43,
  //       PATH: "/admin/branch/roles",
  //       ELEMENT: MartRole,
  //     },
  //     {
  //       TITLE: "branch employees",
  //       KEY: 44,
  //       PATH: "/admin/branch/employees",
  //       ELEMENT: MartEmployee,
  //     },
  //   ],
  // },
  // {
  //   TITLE: "Staff",
  //   ICON: GroupIcon,
  //   KEY: 3,
  //   PATH: "/admin/staff",
  //   SUBNAV: [
  //     {
  //       TITLE: "Role",
  //       KEY: 31,
  //       PATH: "/admin/staff/role",
  //       SUBSUBNAV: [
  //         {
  //           TITLE: "Role",
  //           KEY: 311,
  //           PATH: "/admin/staff/role/role",
  //           ELEMENT: Role,
  //         },
  //         {
  //           TITLE: "Roles",
  //           KEY: 312,
  //           PATH: "/admin/staff/role/roles",
  //           ELEMENT: Employee,
  //         },
  //       ],
  //     },
  //     {
  //       TITLE: "Employee",
  //       KEY: 32,
  //       PATH: "/admin/staff/roles",
  //       ELEMENT: Employee,
  //     },
  //   ],
  // },
];

export default BRANCHROUTES;
